module.exports = __webpack_public_path__ + "static/img/credential5.0b301c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/credential/credential5.jpg
// module id = zOVV
// module chunks = 1